// Círculo de iniciales con la paleta corporativa. Presentacional puro: sin hooks de datos, para que
// pueda pintarse dentro de un `.map()` en cualquier pantalla sin arrastrar proveedores — el mismo
// criterio que ya obligó a dejar `PersonAvatar` sin `useAvatarUrl` dentro.
import { getInitials } from '@/utils/strings';
import { avatarColorByIndex, avatarColorForSeed, avatarVars } from '@/utils/avatarPalette';

interface InitialsAvatarProps {
  /** Nombre completo. De aquí salen las iniciales; el color NO se deriva de él salvo vía `seed`. */
  readonly name: string;
  /** Clase de tamaño/tipografía de quien lo monta (`rr-leader-avatar`, `side-avatar`…). */
  readonly baseClass: string;
  /**
   * Posición de la persona en la lista. Con esto el color sigue la SECUENCIA de la paleta, que es lo
   * que se pidió para listas. Tiene precedencia sobre `seed` si llegaran los dos.
   */
  readonly colorIndex?: number;
  /**
   * Semilla estable (id de la persona; su nombre si no hay id) para avatares SUELTOS, donde no hay
   * posición que seguir. Así la misma persona conserva su color entre pantallas.
   */
  readonly seed?: string | null;
}

export function InitialsAvatar({ name, baseClass, colorIndex, seed }: InitialsAvatarProps) {
  const fondo = colorIndex === undefined
    ? avatarColorForSeed(seed ?? name)
    : avatarColorByIndex(colorIndex);

  return (
    <span className={`pmp-avatar ${baseClass}`} style={avatarVars(fondo)} aria-hidden="true">
      {getInitials(name)}
    </span>
  );
}
